import { render, staticRenderFns } from "./TeethSelector.vue?vue&type=template&id=f620970a"
import script from "./TeethSelector.vue?vue&type=script&lang=js"
export * from "./TeethSelector.vue?vue&type=script&lang=js"
import style0 from "./TeethSelector.vue?vue&type=style&index=0&id=f620970a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports